module.exports = __webpack_public_path__ + "img/lg_ring_y_s_1_null@3x.307db6b7.png";